export const AI_REVIEW_SUMMARY_MAX_LENGTH = 180;

export const AI_REVIEW_SUMMARY_HELPER_TEXT =
  'Maximum 180 characters. Replaces the generated review summary on the offer page. Leave empty to use the generated summary.';

export function toAiReviewSummaryFormValue(value?: string | null) {
  return value?.trim() ?? '';
}

export function toAiReviewSummaryPayload(value?: string | null) {
  const trimmed = value?.trim() ?? '';
  return trimmed.length > 0 ? trimmed : null;
}
